const ISOToDateString = ISO => String(ISO).split('T')[0];

export default ISOToDateString;
